import { client } from '../client';
import { ProviderAvailability } from './types/ProviderAvailability';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export interface Payload {
  start_time: string;
  end_time: string;
  synchronous: boolean;
  asynchronous: boolean;
}

export const updateUserAvailability = async (
  user_id: number,
  availability_id: number,
  payload: Payload,
  userRole?: string,
): Promise<ProviderAvailability> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.patch<ProviderAvailability>(
    `${prefix}/users/${user_id}/user_availability/${availability_id}`,
    payload,
  );

  return data;
};
